export default "__VITE_ASSET__v1DoFn1H__"